import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import {ActivatedRoute} from '@angular/router';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {CotacaoVM, Pessoa} from 'src/app/api/model/cotacao-online/cotacaoVM';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {GeoLocalizacaoService} from 'src/app/api/module/erp/shared/geo-localizacao/geo-localizacao.service';
import {ListaAuxiliaresService} from 'src/app/api/module/erp/shared/lista-auxiliares/lista-auxiliares.service';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {CotacaoService} from 'src/app/api/module/portal/services/cotacao/cotacao.service';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';
import {VerificaEmail} from 'src/app/components/helper/form-validators/verifica-email';
import {VerificaNome} from 'src/app/components/helper/form-validators/verifica-nome';
import {CaptchaComponent} from 'src/app/pages/area-logada/shared/components/captcha/captcha.component';

export interface ProdutoDM {
  id: string;
  abrangencia: string;
  descricao: string;
  numeroRegistro: string;
  valor: number;
  idProduto: string;
  idPessoa: string;
  idProfissao: string;
}

@Component({
  selector: 'app-landing-page-simulador-preco',
  templateUrl: './landing-page-simulador-preco.component.html',
  styleUrls: ['./landing-page-simulador-preco.component.scss'],
})
export class LandingPageSimuladorPrecoComponent implements OnInit {
  modalConfirmarRef?: BsModalRef;
  @ViewChild('modalConfimar') modalConfimar: any;
  formCotacao!: UntypedFormGroup;
  blockTemplate: BlockTemplateComponent | undefined;
  isLinear = false;
  heOdonto = false;
  listaProfissoes: any = [];
  listaEstados: any = [];
  listaCidadePorEstado: any = [];
  heOutraProfissao: boolean = false;
  private _cotacaoVM = new CotacaoVM();
  dadosParaCompartilhar: any = [];
  dependentesList: any[] = [];
  isVisible = false;
  idCotacao!: string;
  idOperadora!: any;
  utmSource!: string;
  utmCampaign!: string;
  utmMedium!: string;
  listaProdutosDM: {dadosProdutosDM: ProdutoDM[]}[] = [];
  listaProdutosDM_: any;
  logotipoUrl: any;
  minDate: Date;
  maxDate: Date;
  bsConfig: Partial<BsDatepickerConfig>;
  buttonEnabled: boolean = false;
  tipoPlano: string = '';
  _tipoProduto_E_OperadoraEnum = TipoProduto_E_OperadoraEnum;
  currentSlideIndex = 0;
  // Array com os dados das operadoras hoje esta chumbado porque sao estasoperadoras que atendemos para odonto
  operadoras = [
    {
      idOperadora: 'F40F7481-5FF7-4FF0-80DF-F62804AF08AB',
      nome: 'Uniodonto',
      valorEnum: TipoProduto_E_OperadoraEnum.UNIODONTO,
    },
    {
      idOperadora: '0203B3AC-14CA-482E-9555-73504795E32C',
      nome: 'Odontoprev',
      valorEnum: TipoProduto_E_OperadoraEnum.ODONTOPREV,
    },
    {
      idOperadora: '2341DECD-83C7-410F-B550-8216BA14AC96',
      nome: 'Unimed Odonto',
      valorEnum: TipoProduto_E_OperadoraEnum.UNIMED_ODONTO,
    },
  ];

  // Controlando o estado das abas com um objeto
  abaCadastrada: {[key in any]: boolean} = {
    [TipoProduto_E_OperadoraEnum.UNIMED_ODONTO]: false,
    [TipoProduto_E_OperadoraEnum.UNIODONTO]: false,
    [TipoProduto_E_OperadoraEnum.ODONTOPREV]: false,
  };

  // Objeto que irá armazenar as listas de produtos para cada operadora
  listasDeProdutos: {[key in any]: any[]} = {
    [TipoProduto_E_OperadoraEnum.UNIMED_ODONTO]: [],
    [TipoProduto_E_OperadoraEnum.UNIODONTO]: [],
    [TipoProduto_E_OperadoraEnum.ODONTOPREV]: [],
    [TipoProduto_E_OperadoraEnum.SAUDE]: [],
  };

  dadosTipoOPeradoraSelecionadaVM: any;
  // Variável para armazenar a operadora atual selecionada padrao para odonto
  tipoOperadoraSelecionada: TipoProduto_E_OperadoraEnum = TipoProduto_E_OperadoraEnum.UNIMED_ODONTO;
  tipoOperadoraSelecionadaSaude: TipoProduto_E_OperadoraEnum = TipoProduto_E_OperadoraEnum.SAUDE;
  preLeadId: any;
  messagemSpinner: string = 'Aguarde...';
  captchaToken: string | null = null;
  @ViewChild('captcha') captcha: CaptchaComponent;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private _cotacaoService: CotacaoService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private bsLocaleService: BsLocaleService,
    private route: ActivatedRoute,
    private _spinnerService: SpinnerService,
    private _geoSerice: GeoLocalizacaoService,
    private _listaAux: ListaAuxiliaresService,
    private _errorLoggingService: ErrorLoggingService,
    private _modalService: BsModalService,
  ) {
    this.bsLocaleService.use('pt-br');
    this.minDate = new Date(1900, 0, 1);
    this.maxDate = new Date();
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
      maxDate: new Date(),
    };
  }

  ngOnInit(): void {
    this.buscarEstadaos();
    this.criarFormCotacao();
    this.buscarProfissoes();
    this.receberDadosCompartilhados();
    this.listaProdutosDM_ = [
      {
        id: 'a721cafc-eb19-4bee-8c11-bc37c2210de5',
        abrangencia: 'Estadual',
        descricao: 'Plano Completo',
        numeroRegistro: '654321',
        valor: 350.02,
        idProduto: '2',
        idPessoa: '101',
        idProfissao: '201',
      },
      {
        id: 'a721cafc-eb19-4bee-8c11-bc37c2210de5',
        abrangencia: 'Estadual',
        descricao: 'Plano Completo',
        numeroRegistro: '654321',
        valor: 350.01,
        idProduto: '2',
        idPessoa: '101',
        idProfissao: '201',
      },
      {
        id: 'a721cafc-eb19-4bee-8c11-bc37c2210de5',
        abrangencia: 'Estadual',
        descricao: 'Plano Completo',
        numeroRegistro: '654321',
        valor: 350.04,
        idProduto: '2',
        idPessoa: '101',
        idProfissao: '201',
      },
    ];

    this.route.params.subscribe(params => {
      this.idCotacao = params['id'];
    });

    // Pegando os parâmetros de consulta (utm_source, utm_campaign)
    this.route.queryParams.subscribe(queryParams => {
      this.utmSource = queryParams['utm_source'];
      this.utmCampaign = queryParams['utm_campaign'];
      this.utmMedium = queryParams['utm_medium'];
    });
  }

  criarFormCotacao() {
    this.formCotacao = this._formBuilder.group({
      nome: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(60),
        VerificaNome,
      ]),
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.email,
        Validators.minLength(2),
        Validators.maxLength(250),
        Validators.required,
        VerificaEmail,
      ]),
      contato: ['', Validators.required],
      age: ['', Validators.required],
      idEstado: [null, Validators.required],
      idProfissao: [null, Validators.required],
      idCidade: [null, Validators.required],
      totalDependentes: ['', Validators.pattern('[1-6]')],
      aniversariosDependentes: this._formBuilder.array([]),
      dependentes: this._formBuilder.array([]),
    });

    this.formCotacao.controls['idEstado'].valueChanges.subscribe((value: any) => {
      this.filtrarCidadePorEstado(value);
    });

    this.formCotacao.controls['idProfissao'].valueChanges.subscribe((value: any) => {
      let ideOutraProfissao = '00000000-0000-0000-0000-000000000000';
      // se for outra exibir heOutraProfissao =true
      if (value === ideOutraProfissao) this.heOutraProfissao = true;
      else this.heOutraProfissao = false;
    });

    this.formCotacao.controls['totalDependentes'].valueChanges.subscribe((value: any) => {
      if (parseInt(value) > 6) this.toastr.warning('informe apenas 6 dependentes.');
      else {
        this.atualizarAniversariosDependentes(value);
      }
    });
  }

  onAba1() {}
  get dependentes(): UntypedFormArray {
    return this.formCotacao.get('aniversariosDependentes') as UntypedFormArray;
  }

  // Método para atualizar o FormArray baseado no número de dependentes
  atualizarAniversariosDependentes(totalDependentes: number) {
    const aniversariosDependentes = this.formCotacao.get('aniversariosDependentes') as UntypedFormArray;
    aniversariosDependentes.clear(); // Limpar qualquer entrada anterior

    for (let i = 0; i < totalDependentes; i++) {
      aniversariosDependentes.push(
        this._formBuilder.group({
          dataNascimentoDependente: ['', Validators.required],
        }),
      );
    }
  }

  barraDeProgressoPasso1() {
    this.buttonEnabled =
      this.isVisible &&
      this.formCotacao.controls['idProfissao'].valid &&
      this.formCotacao.controls['idProfissao'].value !== '' &&
      this.formCotacao.controls['idEstado'].valid &&
      this.formCotacao.controls['idEstado'].value !== '' &&
      this.formCotacao.controls['idCidade'].valid &&
      this.formCotacao.controls['idCidade'].value !== '' &&
      this.formCotacao.controls['age'].valid &&
      this.formCotacao.controls['age'].value !== '';
  }

  barraDeProgressoPasso2() {
    return (
      this.formCotacao.controls['nome'].valid &&
      this.formCotacao.controls['nome'].value !== '' &&
      this.formCotacao.controls['email'].valid &&
      this.formCotacao.controls['email'].value !== '' &&
      this.formCotacao.controls['contato'].valid &&
      this.formCotacao.controls['contato'].value !== ''
    );
  }
  goToNextStep(stepper: MatStepper): void {
    // Avançando para o próximo passo
    stepper.next();
    //this.cadastrarLead();
  }
  validarCampos(stepper: MatStepper) {
    switch (stepper.selectedIndex) {
      case 0:
        if (
          this.formCotacao.controls['idProfissao'].invalid ||
          this.formCotacao.controls['idProfissao'].value === '' ||
          this.formCotacao.controls['idEstado'].invalid ||
          this.formCotacao.controls['idEstado'].value === '' ||
          this.formCotacao.controls['idCidade'].invalid ||
          this.formCotacao.controls['idCidade'].value === '' ||
          this.formCotacao.controls['age'].invalid ||
          this.formCotacao.controls['age'].value === ''
        ) {
          this.toastr.warning('Preencha todos os campos, por favor!');
        } else {
          this.buttonEnabled = true;
          stepper.next();
        }
        break;
      case 1:
        if (this.formCotacao.controls['nome'].invalid || this.formCotacao.controls['nome'].value === '') {
          this.toastr.warning('Nome inválido!');
        } else if (this.formCotacao.controls['contato'].invalid || this.formCotacao.controls['contato'].value === '') {
          this.toastr.warning('Número de celular inválido!');
        } else if (this.formCotacao.controls['email'].invalid || this.formCotacao.controls['email'].value === '') {
          this.toastr.warning('email inválido!');
        } else {
          //Passei a UNIMED ODONTO POR SER A ABA QUE CARREGA POR PADRAO, AS DEMAS VAI MAPEAR PELO CLICK
          this.cadastrarLead(stepper, TipoProduto_E_OperadoraEnum.UNIMED_ODONTO);
        }
        break;
      case 2:
        break;
      default:
        stepper.next();
        break;
    }
  }

  adicionarDependente() {
    if (this.dependentes.length >= 6) {
      this.toastr.warning('Você pode adicionar no máximo 6 dependentes.');
      return;
    }

    const novoDependente = this._formBuilder.group({
      dataNascimentoDependente: ['', Validators.required],
    });

    this.dependentes.push(novoDependente);
    this.dependentesList.push({dataNascimentoDependente: ''});
  }

  removerDependente(index: number) {
    this.dependentes.removeAt(index);
    this.dependentesList.splice(index, 1);
  }

  pegarValoresUrl() {
    // Usando ActivatedRoute para acessar os parâmetros
    this.tipoPlano = this.route.snapshot.paramMap.get('tipoPlano') || ''; //saude ou odonto
    this.idOperadora = this.route.snapshot.paramMap.get('id') || '';
  }

  cadastrarLead(stepper?: MatStepper, tipoOperadora?: any) {
    if (!this.captchaToken) {
      this.toastr.error('Por favor, complete o CAPTCHA antes de enviar.', 'Aviso');
      return;
    }
    this.iniciarSpinner('Calculando os melhores planos e tabelas de preços...');
    this.pegarValoresUrl();
    this.preencherDadosCotacaoVM(tipoOperadora);

    const dadosLeadVM = {
      campaingOrigin: [this.utmSource, this.utmCampaign].filter(value => value && value !== '').join('/') || null,
      professionId: this._cotacaoVM?.idProfissao || '',
      stateId: this._cotacaoVM?.idEstado || '',
      cityId: this._cotacaoVM?.idCidade || '',
      birthday: this._cotacaoVM?.pessoa?.dataNascimento || '',
      holderName: this._cotacaoVM?.pessoa?.nomeCompleto || '',
      email: this._cotacaoVM?.email || '',
      cellPhone: this._cotacaoVM?.contato || '',
      productType:
        this._cotacaoVM?.descricaoProduto?.toLowerCase() === 'unimed fesp'
          ? TipoProduto_E_OperadoraEnum.SAUDE
          : TipoProduto_E_OperadoraEnum.ODONTO || 1,
      dependentsBirthDates: this._cotacaoVM.dependentes || [],
    } as any;

    this._cotacaoService
      .CarregarPlanosLead(dadosLeadVM, this.captchaToken)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: (dataVM: any) => {
          this.captcha.reset();
          this.captchaToken = null;

          this.preLeadId = '';
          this.preLeadId = dataVM?.preLeadId;
          const listaPlanosRetornoDM = dataVM?.data?.data?.plans;
          if (listaPlanosRetornoDM.length == 0) {
            this.toastr.info('Não retornou nenhum produto para os dados informados.');
            return;
          }

          const produtosExtraidos = this.extrairProdutos(listaPlanosRetornoDM);
          if (!produtosExtraidos.length) return;

          this.logotipoUrl = produtosExtraidos[0]?.logotipoEntidade;
          this.compartilharDados(produtosExtraidos);

          if (!this.heOdonto) {
            this.listasDeProdutos[TipoProduto_E_OperadoraEnum.SAUDE].push(...produtosExtraidos);
          } else {
            this.separarProdutosOdonto(produtosExtraidos);
            this.abaCadastrada[tipoOperadora] = true;
          }

          if (stepper) stepper.next();
        },
        error: (e: any) => {
          this.captcha.reset();
          this.captchaToken = null;
          this._errorLoggingService.logError('Erro ao cadastrar lead - proposta cotacao', e, {
            contexto: 'cadastrarLead',
            dadosEnviados: dadosLeadVM,
          });

          this.toastr.toastrConfig.preventDuplicates = true;
          const mensagemTratada = e?.message?.replace('Error:', '') || '';
          this.toastr.error(
            mensagemTratada.includes('[object Object]')
              ? 'Erro ao tentar cadastrar'
              : mensagemTratada || 'Erro desconhecido',
          );
        },
      });
  }

  separarProdutosOdonto(dados: any) {
    let listaProdutos = dados;

    if (listaProdutos) {
      listaProdutos.forEach((produto: any) => {
        if (produto.nomeOperadora.toLowerCase().includes('unimed')) {
          this.listasDeProdutos[TipoProduto_E_OperadoraEnum.UNIMED_ODONTO].push(produto);
        }
        if (produto.nomeOperadora.toLowerCase().includes('uniodonto')) {
          this.listasDeProdutos[TipoProduto_E_OperadoraEnum.UNIODONTO].push(produto);
        }
        if (produto.nomeOperadora.toLowerCase().includes('odontoprev')) {
          this.listasDeProdutos[TipoProduto_E_OperadoraEnum.ODONTOPREV].push(produto);
        }
        return;
      });
    } else {
      this.toastr.warning('Produtos odonto nao encontrado.');
    }
  }

  private extrairProdutos(itensProdutosDM: any[]): any[] {
    return itensProdutosDM.map((item, index) => {
      return {
        numeroRegistro: item.registerNumberANS,
        nome: item.productName,
        descricao: item.coverageName,
        abrangencia: item?.coverageName || '',
        id: item.productId,
        valor: item.totalPriceValue || 0.0,
        idLead: this.preLeadId,
        idPessoa: item.holderQuote?.idPessoa ?? '',
        idProfissao: item.holderQuote?.professionId ?? '',
        logotipoEntidade: item.branchCompanyLogo || '',
        nomeOperadora: item.operatorName,
        contractProductCompanyId: item.contractProductCompanyId || '',
        branchCompanyContractId: item.branchCompanyContractId || '',
        idOperadora: item.operatorId,
        acomodacao: item?.accommodationName,
      };
    });
  }

  preencherDadosCotacaoVM(tipoOperadora?: any) {
    const formValue = this.formCotacao.value;
    this._cotacaoVM.dependentes = [];
    this._cotacaoVM.dependente = formValue.aniversariosDependentes.length;

    formValue.aniversariosDependentes.forEach((element: {dataNascimentoDependente: string}) => {
      this._cotacaoVM.dependentes.push(element.dataNascimentoDependente);
    });

    this._cotacaoVM.fonte = this.utmSource || 'Portal';
    // Definir valores padrão para as campanhas
    let campanhaSaude = this.utmCampaign || 'UNIMED FESP';
    let campanhaOdonto = this.utmCampaign || 'UNIMED+ODONTO';
    let utmMedium = this.utmMedium || 'UnimedFesp';

    tipoOperadora = tipoOperadora || this.tipoOperadoraSelecionada;

    // Ajustar campanha e descricaoProduto de acordo com o tipoPlano
    if (this.tipoPlano === TipoProduto_E_OperadoraComponent.getDescricao(TipoProduto_E_OperadoraEnum.SAUDE)) {
      this.heOdonto = false;
      campanhaSaude = 'UNIMED FESP';
      campanhaOdonto = '';
      tipoOperadora = this.tipoOperadoraSelecionadaSaude;
      this.tipoOperadoraSelecionada = this.tipoOperadoraSelecionadaSaude;
      this._cotacaoVM.descricaoProduto = 'UNIMED FESP';
    } else if (this.tipoPlano === TipoProduto_E_OperadoraComponent.getDescricao(TipoProduto_E_OperadoraEnum.ODONTO)) {
      // Caso o plano seja de odontologia
      this.heOdonto = true;
      campanhaSaude = '';
      // Se há uma operadora selecionada, usa-se o nome da operadora como campanha
      if (this.dadosTipoOPeradoraSelecionadaVM) {
        campanhaOdonto = this.dadosTipoOPeradoraSelecionadaVM.nome;
        this._cotacaoVM.descricaoProduto = this.dadosTipoOPeradoraSelecionadaVM.nome;
        this.idOperadora = this.dadosTipoOPeradoraSelecionadaVM.idOperadora;
      } else {
        // Caso contrário, utiliza-se o valor padrão de campanha de odontologia
        campanhaOdonto = 'UNIMED+ODONTO';
        this._cotacaoVM.descricaoProduto = 'UNIMED+ODONTO';
      }
    }

    this._cotacaoVM.campanha = campanhaSaude || campanhaOdonto;
    this._cotacaoVM.operadora = this.idOperadora;
    this._cotacaoVM.canal = '';
    this._cotacaoVM.idVendedor = '';
    this._cotacaoVM.pessoa = new Pessoa();
    this._cotacaoVM.pessoa.nomeCompleto = formValue.nome;
    this._cotacaoVM.email = formValue.email;
    this._cotacaoVM.idProfissao = formValue.idProfissao;
    this._cotacaoVM.idEstado = formValue.idEstado;
    this._cotacaoVM.idCidade = formValue.idCidade;
    this._cotacaoVM.contato = formValue.contato;
    this._cotacaoVM.preferenciaContato = formValue.preferenciaContato;
    this._cotacaoVM.pessoa.dataNascimento = formValue.age;
  }
  private compartilharDados(data: any) {
    this.dadosParaCompartilhar = [];
    this.dadosParaCompartilhar.push({
      dadosProdutosDM: data,
    });

    this._compartilharDadosEntreComponentsService &&
      this._compartilharDadosEntreComponentsService.enviarDadosParaOutroComponent(this.dadosParaCompartilhar);
  }

  formatarValorDecimal(valor: number): string {
    return (valor % 1).toFixed(2).split('.')[1];
  }

  receberDadosCompartilhados() {
    this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(dadosProdutosDM => {
      this.listaProdutosDM = [];
      this.listaProdutosDM = dadosProdutosDM;
    });
  }

  comprarOnLine(preLeadId: string, contractProductCompanyId: string, branchCompanyContractId: string) {
    this.iniciarSpinner();

    const novaAba = window.open('', '_blank');

    this._cotacaoService
      .comprarOnline(preLeadId, contractProductCompanyId, branchCompanyContractId)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: (dataVM: any) => {
          if (dataVM.data && novaAba) {
            // Redireciona a aba que já estava aberta
            novaAba.location.href = dataVM.data;
          } else if (dataVM.data) {
            // Fallback: tenta abrir uma nova aba
            window.open(dataVM.data, '_blank');
          }
        },

        error: (e: any) => {
          if (novaAba) {
            novaAba.close();
          }
          this._errorLoggingService.logError('Erro ao Comprar online', e, {
            contexto: 'Comprar Online',
            dadosEnviados: {
              preLeadId: preLeadId,
              contractProductCompanyId: contractProductCompanyId,
              branchCompanyContractId: branchCompanyContractId,
            },
          });

          this.toastr.toastrConfig.preventDuplicates = true;
          const mensagemTratada = e?.message?.replace('Error:', '') || '';
          this.toastr.error(
            mensagemTratada.includes('[object Object]')
              ? 'Erro ao Comprar online'
              : mensagemTratada || 'Erro desconhecido',
          );
        },
      });
  }

  isConcorda(e: any) {
    if (e.target.checked) {
      this.isVisible = true;
      this.barraDeProgressoPasso1();
    } else this.isVisible = false;
    this.barraDeProgressoPasso1();
  }
  //operadora eduardo

  onChangeCotacaoResultado(tipoOperadora: any) {
    // Busca a operadora através do tipo (enum)
    const retrnoDM = this.operadoras.find(operadora => operadora.valorEnum === tipoOperadora);
    this.dadosTipoOPeradoraSelecionadaVM = retrnoDM;

    // Atualiza o tipo de operadora selecionada
    this.tipoOperadoraSelecionada = tipoOperadora;

    // Chama a função para buscar a lista de produtos da operadora
    this.buscarListaDeOperadora(tipoOperadora);
  }

  buscarListaDeOperadora(tipoOperadora: TipoProduto_E_OperadoraEnum): any[] {
    return this.listasDeProdutos[tipoOperadora];
  }
  voltar() {
    window.open(`#/portal`, '_self');
  }

  scrollNext(): void {
    const container = document.querySelector('.carousel-content') as HTMLElement;
    container.scrollLeft += container.offsetWidth; // Rola para a próxima "página"
  }

  scrollPrev(): void {
    const container = document.querySelector('.carousel-content') as HTMLElement;
    container.scrollLeft -= container.offsetWidth; // Rola para a página anterior
  }

  iniciarSpinner(mensagem: string = 'Carregando...') {
    this._spinnerService.show(mensagem);
  }

  pararSpinner() {
    this._spinnerService.hide();
  }

  buscarEstadaos() {
    this._geoSerice.ListStates().subscribe(data => {
      this.listaEstados = data;
      // Encontrar o índice do elemento "Outro"
      const indexOutro = this.listaEstados.findIndex((item: {name: string}) => item.name === 'Outro');

      // Remover o elemento "Outro" da lista, se encontrado
      if (indexOutro > -1) {
        const outro = this.listaEstados.splice(indexOutro, 1)[0];
        // Adicionar o elemento "Outro" de volta no final da lista
        this.listaEstados.push(outro);
      }
    });
  }

  filtrarCidadePorEstado(id: any[]) {
    if (id) {
      this.formCotacao.patchValue({idCidade: null});
      let state = [];
      state.push(id);
      this._geoSerice.ListCitiesByStates(state).subscribe(data => {
        this.listaCidadePorEstado = data;
      });
    }
  }

  buscarProfissoes() {
    this._listaAux.listaProfissao().subscribe(data => {
      this.listaProfissoes = data && data;
    });
  }

  decline(): void {
    this.toastr.info('E-mail com link enviado por e-mail.');
    this.modalConfirmarRef?.hide();
  }
  // 01
  abrirModalConfirmar() {
    this.modalConfirmarRef = this._modalService.show(this.modalConfimar, {
      backdrop: 'static',
      class: 'modal-md',
      id: 'confirmar',
    });
    this.pararSpinner();
  }

  confirmar(): void {
    this.toastr.success('redirecionando...');
    const url =
      'https://portal.geia.com.br/Conta/Login/10bb5d43-6677-4730-bf92-d3928c7dd05d?p=f66d2633-b260-4526-85f3-fb0af0f0a343&idProfissao=3a34b9b4-3a2e-4cb2-afe2-ccb01c7f052d';
    window.open(url);

    //redirecionar para a url de autenticacao
    this.modalConfirmarRef?.hide();
  }
}
